export default __webpack_public_path__ + "static/media/icon-pocketcasts.bf6a9c35.svg";